import { useAtomValue } from 'jotai';
import { useEffect } from 'react';
import { primaryFilterVisibilityAtom } from '../atoms';

// to make this extensible, extract series name and atom as params
function useToggleSeries({ instance, enabled = false }) {
  const showSeries = useAtomValue(primaryFilterVisibilityAtom);

  useEffect(() => {
    if (enabled && instance) {
      const action = showSeries ? 'legendSelect' : 'legendUnSelect';
      instance.dispatchAction({
        type: action,
        name: 'Primary',
      });
    }
  }, [enabled, instance, showSeries]);
}

export default useToggleSeries;
